<template>
  <div class="phonePage">
    <h1>订单查询</h1>
    <van-form @submit="onSubmit" class="order_form">
      <van-field
          v-model="psp_order_id"
          name="交易单号"
          label="交易单号"
          placeholder="交易单号"
          type="digit"
          right-icon="close"
          @click-right-icon="clearFiled"
      />

      <van-field
          readonly
          clickable
          name="出货状态"
          :value="orderOutStatus"
          label="出货状态"
          placeholder="点击选择出货状态"
          @click="showStatusPicker = true"
          clearable
          right-icon="close"
          @click-right-icon.stop="clearFiled"
      />
      <van-popup v-model="showStatusPicker" position="bottom">
        <van-picker
            show-toolbar
            :columns="outStatusList"
            @confirm="onConfirm"
            @cancel="showStatusPicker = false"
        />
      </van-popup>
      <van-field
          readonly
          clickable
          name="景区名称"
          :value="storeIdList"
          label="景区名称"
          placeholder="点击选择景区名称"
          @click="handleStorePopUp"
          right-icon="close"
          @click-right-icon.stop="clearFiled"
      />
      <van-popup v-model="showStorePicker" position="bottom">
        <van-field
            class="searchBox"
            v-model="keyWord"
            center
            placeholder="搜索景区名称"
        >
          <template #button>
            <van-button size="small" type="primary" @click.prevent="keySearch">搜索</van-button>
          </template>
        </van-field>
        <van-picker
            class="storeBox"
            show-toolbar
            toolbar-position="bottom"
            :columns="storeList"
            @confirm="onStoreConfirm"
            @cancel="showStorePicker = false"
        />
      </van-popup>
      <van-field
          readonly
          clickable
          name="时间范围"
          :value="dateRange"
          label="时间范围"
          placeholder="点击选择时间范围"
          @click="showDatePicker = true"

      />
      <van-popup v-model="showDatePicker" position="bottom">
        <van-picker
            show-toolbar
            :columns="dateList"
            @confirm="onDateConfirm"
            @cancel="showDatePicker = false"
        />
      </van-popup>
<!--      <van-field-->
<!--          v-show="isShowMore"-->
<!--          readonly-->
<!--          clickable-->
<!--          name="开始日期"-->
<!--          :value="calendarStartVal"-->
<!--          label="开始日期"-->
<!--          placeholder="点击选择开始日期"-->
<!--          @click="showCalendar = true"-->
<!--          right-icon="close"-->
<!--          @click-right-icon.stop="clearFiled"-->
<!--      />-->

<!--      <van-popup v-model="showCalendar" position="bottom">-->
<!--        <van-datetime-picker type="datetime" :min-date="minDate"-->
<!--                             @confirm="onCalendarConfirm"-->
<!--                             @cancel="showCalendar = false"-->
<!--                             :formatter="formatter" />-->
<!--      </van-popup>-->
<!--      <van-field-->
<!--          v-show="isShowMore"-->
<!--          readonly-->
<!--          clickable-->
<!--          name="结束日期"-->
<!--          :value="calendarEndVal"-->
<!--          label="结束日期"-->
<!--          placeholder="点击选择结束日期"-->
<!--          @click="showEndCalendar = true"-->
<!--          right-icon="close"-->
<!--          @click-right-icon.stop="clearFiled"-->
<!--      />-->

<!--      <van-popup v-model="showEndCalendar" position="bottom">-->
<!--        <van-datetime-picker type="datetime" :min-date="minDate"-->
<!--                             @confirm="onCalendarEndConfirm"-->
<!--                             @cancel="showEndCalendar = false"-->
<!--                             :formatter="formatter" />-->
<!--      </van-popup>-->



      <div style="margin: 16px 16px 0 16px;">
        <van-button round block type="info" native-type="submit" color="#2ad1c4">查询</van-button>
<!--        <div class="showMoreBox">-->
<!--          <p v-show="!isShowMore" @click="changeShowMore">-->
<!--            <span>更多筛选</span><van-icon name="arrow-down" />-->
<!--          </p>-->
<!--          <p v-show="isShowMore" @click="changeShowMore">-->
<!--            <span>收起</span><van-icon name="arrow-up" />-->
<!--          </p>-->
<!--        </div>-->
      </div>

    </van-form>
    <div class="tableList">
      <div v-for="item in tableData" :key="item.transaction_id" class="listBox">
        <div class="table_row">
          <div>交易单号：</div>
          <div>{{item.psp_order_id}}</div>
        </div>
        <div class="table_row">
          <div>支付时间：</div>
          <div>{{item.finish_time || '-'}}</div>
        </div>
        <div class="table_row">
          <div>支付方式：</div>
          <div>{{ item.psp_name | PSPNameFilter }}</div>
        </div>
        <div class="table_row">
          <div>支付状态：</div>
          <div>
            <van-tag
                v-if="
                    item.transaction_status == 'ING' &&
                    diffTimestamp(serverTimeNow, item.add_time) >
                      OUT_TIMEOUT
                  "
                :type="'info'"
            >
              {{ 'CANCEL' | payStatusFilter }}
            </van-tag>
            <van-tag v-else :type="item.transaction_status | statusFilter">
              {{ item.transaction_status | payStatusFilter }}
            </van-tag>
          </div>
        </div>
        <div class="table_row">
          <div>出货状态：</div>
          <div>
            <van-tag
                v-if="item.order_out_status"
                :type="item.order_out_status | statusFilter"
            >
              {{ item.order_out_status | outStatusFilter }}
            </van-tag>
            <van-tag
                v-else-if="
              (item.order_pay_status == 'SUCCESS' ||
                item.order_pay_status == 'DOUBLEPAY') &&
              diffTimestamp(serverTimeNow, item.add_time) > OUT_TIMEOUT &&
              item.order_out_status ==''"
                :type="'OVERTIME' | statusFilter"
            >
              {{ 'OVERTIME' | outStatusFilter }}
            </van-tag>
            <van-tag v-else-if="(item.order_pay_status == 'SUCCESS' ||
              item.order_pay_status == 'DOUBLEPAY') &&
              diffTimestamp(serverTimeNow, item.add_time) < OUT_TIMEOUT &&
              item.order_out_status ==''"
                     :type="'ING' | statusFilter">
              {{ 'ING' | outStatusFilter }}
            </van-tag>
            <van-tag v-else-if="item.order_out_status == '出货超时'"
                     :type="'WAZ' | statusFilter">
              {{ '出货超时' | outStatusFilter }}
            </van-tag>
            <van-tag v-else-if="item.order_out_status == '通讯超时'"
                     :type="'WAZ' | statusFilter">
              {{ '通讯超时' | outStatusFilter }}
            </van-tag>
            <van-tag v-else-if="item.order_out_status == '出货异常'"
                     :type="'WAZ' | statusFilter">
              {{ '出货异常' | outStatusFilter }}
            </van-tag>
            <van-tag v-else :type="'WAZ' | statusFilter">
              {{ item.order_out_status | outStatusFilter }}
            </van-tag>
          </div>
        </div>
        <div class="table_row">
          <div>退款类型：</div>
          <div>
            <van-tag
                v-if="item.refund_status"
                size="small"
                :type="item.refund_status | statusFilter"
            >
              {{ item.refund_status | refundStatusFilter }}
            </van-tag>
            <van-tag v-else>未退款</van-tag>
          </div>
        </div>
<!--        <div class="table_row">-->
<!--          <div>退款备注：</div>-->
<!--&lt;!&ndash;          <div>{{item.psp_order_id}}</div>&ndash;&gt;-->
<!--          <div>-&#45;&#45;&#45;&#45;</div>-->
<!--        </div>-->
        <div class="table_row">
          <div>订单金额：</div>
          <div>&yen;{{item.genesis === '777'? (item.amount / 100).toFixed(2): item.amount}}</div>
        </div>
        <div class="table_row">
          <div>实付金额：</div>
          <div>&yen;{{item.genesis === '777'? (item.actual_collection / 100).toFixed(2): item.actual_collection}}</div>
        </div>
        <div class="table_row">
          <div>已退金额：</div>
          <div>&yen;{{item.genesis === '777'? (item.refund_amount === 0 ? 0 :(item.refund_amount / 100).toFixed(2)):
              (item.refund_status && item.transaction_status === 'SUCCESS'? item.amount : item.refund_amount)
            }}</div>
        </div>
        <div class="table_row">
          <div>退款时间：</div>
          <div>{{item.refund_time }}</div>
        </div>
        <div class="table_row">
          <div>是否重复支付：</div>
          <div>
            <van-tag v-if="item.order_pay_status == 'DOUBLEPAY'" :type="'danger'">
              {{ '是' }}
            </van-tag>
            <van-tag v-else :type="'primary'">
              {{ '否' }}
            </van-tag>
          </div>
        </div>
        <div class="table_row">
          <div>设备名称：</div>
          <div>【{{ item.device_name || '-' }}】</div>
        </div>
        <div class="table_row">
          <div>商品名称：</div>
          <div>{{ item.goods_name || '-' }}</div>
        </div>
        <div class="table_row">
          <div>货道：</div>
          <div>{{ Number(item.channel) + 1 }}</div>
        </div>
        <div class="table_row">
          <div>数据来源：</div>
          <div>{{ item.genesis || '-' }}</div>
        </div>
        <div class="table_btn">
          <van-button
              round block
              v-if="
                    (!item.refund_status && item.transaction_status === 'SUCCESS') ||
                    (item.genesis === '777' && item.amount !== item.refund_amount)
                  "
              size="medium"
              type="warning"
              @click="handleManualRefund(item)"
          >
            <span>退款</span>
          </van-button>

          <van-tag v-if="(item.genesis !== '777' && item.refund_status) || (item.genesis === '777' && item.amount === item.refund_amount)"
                   size="small" type="primary">
            已退款
          </van-tag>
        </div>
        <template v-if="item.children">
          <div v-for="inner in item.children" :key="inner.transaction_id" class="innerBox">
            <div class="table_row">
              <div>交易单号：</div>
              <div>{{inner.psp_order_id}}</div>
            </div>
            <div class="table_row">
              <div>支付时间：</div>
              <div>{{inner.finish_time || '-'}}</div>
            </div>
            <div class="table_row">
              <div>支付方式：</div>
              <div>{{ inner.psp_name | PSPNameFilter }}</div>
            </div>
            <div class="table_row">
              <div>支付状态：</div>
              <div>
                <van-tag
                    v-if="
                    inner.transaction_status == 'ING' &&
                    diffTimestamp(serverTimeNow, inner.add_time) >
                      OUT_TIMEOUT
                  "
                    :type="'info'"
                >
                  {{ 'CANCEL' | payStatusFilter }}
                </van-tag>
                <van-tag v-else :type="inner.transaction_status | statusFilter">
                  {{ inner.transaction_status | payStatusFilter }}
                </van-tag>
              </div>
            </div>
            <div class="table_row">
              <div>出货状态：</div>
              <div>
                <van-tag
                    v-if="inner.order_out_status"
                    :type="inner.order_out_status | statusFilter"
                >
                  {{ inner.order_out_status | outStatusFilter }}
                </van-tag>
                <van-tag
                    v-else-if="
              (inner.order_pay_status == 'SUCCESS' ||
                inner.order_pay_status == 'DOUBLEPAY') &&
              diffTimestamp(serverTimeNow, inner.add_time) > OUT_TIMEOUT &&
              inner.order_out_status ==''"
                    :type="'OVERTIME' | statusFilter"
                >
                  {{ 'OVERTIME' | outStatusFilter }}
                </van-tag>
                <van-tag v-else-if="(inner.order_pay_status == 'SUCCESS' ||
              inner.order_pay_status == 'DOUBLEPAY') &&
              diffTimestamp(serverTimeNow, item.add_time) < OUT_TIMEOUT &&
              inner.order_out_status ==''"
                         :type="'ING' | statusFilter">
                  {{ 'ING' | outStatusFilter }}
                </van-tag>
                <van-tag v-else-if="inner.order_out_status == '出货超时'"
                         :type="'WAZ' | statusFilter">
                  {{ '出货超时' | outStatusFilter }}
                </van-tag>
                <van-tag v-else-if="inner.order_out_status == '通讯超时'"
                         :type="'WAZ' | statusFilter">
                  {{ '通讯超时' | outStatusFilter }}
                </van-tag>
                <van-tag v-else-if="inner.order_out_status == '出货异常'"
                         :type="'WAZ' | statusFilter">
                  {{ '出货异常' | outStatusFilter }}
                </van-tag>


                <van-tag v-else-if="inner.order_out_status == '吐货成功'"
                         :type="'吐货成功' | statusFilter">
                  {{ '吐货成功' | outStatusFilter }}
                </van-tag>
                <van-tag v-else-if="inner.order_out_status == '等待吐货'"
                         :type="'等待吐货' | statusFilter">
                  {{ '等待吐货' | outStatusFilter }}
                </van-tag>
                <van-tag v-else-if="inner.order_out_status == '还未吐货'"
                         :type="'还未吐货' | statusFilter">
                  {{ '还未吐货' | outStatusFilter }}
                </van-tag>
                <van-tag v-else-if="inner.order_out_status == '出货失败'"
                         :type="'出货失败' | statusFilter">
                  {{ '出货失败' | outStatusFilter }}
                </van-tag>
                <van-tag v-else :type="'WAZ' | statusFilter">
                  {{ inner.order_out_status | outStatusFilter }}
                </van-tag>
              </div>
            </div>
            <div class="table_row">
              <div>退款类型：</div>
              <div>
                <van-tag
                    v-if="inner.refund_status"
                    size="small"
                    :type="inner.refund_status | statusFilter"
                >
                  {{ inner.refund_status | refundStatusFilter }}
                </van-tag>
              </div>
            </div>
<!--            <div class="table_row">-->
<!--              <div>退款备注：</div>-->
<!--&lt;!&ndash;              <div>{{item.refund_status}}</div>&ndash;&gt;-->
<!--              <div>&#45;&#45;&#45;&#45;&#45;&#45;</div>-->
<!--            </div>-->
            <div class="table_row">
              <div>订单金额：</div>
              <div>&yen;{{inner.genesis === '777'? (inner.amount / 100).toFixed(2): inner.amount}}</div>
            </div>
            <div class="table_row">
              <div>实付金额：</div>
              <div>&yen;{{inner.genesis === '777'? (inner.actual_collection / 100).toFixed(2): inner.actual_collection}}</div>
            </div>
            <div class="table_row">
              <div>已退金额：</div>
              <div>&yen;{{inner.genesis === '777'? (item.refund_amount === 0 ? 0 :(inner.refund_amount / 100).toFixed(2)):
                  (inner.refund_status && inner.transaction_status === 'SUCCESS'? inner.amount : inner.refund_amount)
                }}</div>
            </div>
            <div class="table_row">
              <div>退款时间：</div>
              <div>{{inner.refund_time }}</div>
            </div>
            <div class="table_row">
              <div>是否重复支付：</div>
              <div>
                <van-tag v-if="inner.order_pay_status == 'DOUBLEPAY'" :type="'danger'">
                  {{ '是' }}
                </van-tag>
                <van-tag v-else :type="'primary'">
                  {{ '否' }}
                </van-tag>
              </div>
            </div>
            <div class="table_row">
              <div>设备名称：</div>
              <div>【{{ inner.device_name || '-' }}】</div>
            </div>
            <div class="table_row">
              <div>商品名称：</div>
              <div>{{ inner.goods_name || '-' }}</div>
            </div>
            <div class="table_row">
              <div>货道：</div>
              <div>{{ Number(inner.channel) + 1 }}</div>
            </div>
            <div class="table_row">
              <div>数据来源：</div>
              <div>{{ inner.genesis || '-' }}</div>
            </div>
            <div class="table_btn">
              <van-button
                  round block
                  v-if="
                    (!inner.refund_status && inner.transaction_status === 'SUCCESS') ||
                    (inner.genesis === '777' && inner.amount !== inner.refund_amount)
                  "
                  size="medium"
                  type="warning"
                  @click="handleManualRefund(inner)"
              >
                <span>退款</span>
              </van-button>

              <van-tag v-if="(inner.genesis !== '777' && inner.refund_status) || (inner.genesis === '777' && inner.amount === inner.refund_amount)"
                       size="small" type="primary">
                已退款
              </van-tag>
            </div>
          </div>
        </template>

      </div>
      <van-pagination v-if="tableData.length > 0" v-model="page" :total-items="total" :items-per-page="pageSize" @change="changePage" />
      <div v-else class="noData">暂无数据......</div>
    </div>
    <van-dialog v-model="dialogVisible" title="是否确认退款？" show-cancel-button @confirm="fakeManuanlRefund">
      <div>
        交易单号：
        <p>
          <van-tag type="warning">{{ dialogForm.psp_order_id }}</van-tag>
        </p>
      </div>
      <div>
        支付时间：
        <p><van-tag type="warning">{{ dialogForm.finish_time || '-' }} </van-tag></p>
      </div>
      <div>
        商品名称：
        <p><van-tag type="warning">{{ dialogForm.goods_name || '-' }} </van-tag></p>
      </div>
      <div v-if="dialogForm.params && dialogForm.params.genesis !== '777'">
        退款金额：
        <p><van-tag type="warning" v-if="dialogForm.params && dialogForm.params.genesis !== '777'">{{ dialogForm.amount || '-' }} </van-tag></p>
      </div>
      <div v-else>
        <p>
          <van-field
                     v-model="dialogForm.refundMoney"
                     name="退款金额"
                     label="退款金额"
                     :placeholder="'可退' + ((dialogForm.amount - dialogForm.refund_amount)/100).toFixed(2)+ '元'"
                     right-icon="close"
                     @click-right-icon="clearFiled"
          />
        </p>
      </div>
      <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }" >退款原因(必填)：</van-divider>
      <div class="myCheckBox">
        <!-- <van-checkbox-group v-model="reasonList">
          <van-checkbox  v-for="res in realReasons" :name="res.value">{{ res.label }}</van-checkbox>
        </van-checkbox-group> -->
      </div>

<!--      <div>-->
<!--        <van-field-->
<!--            v-model="refundDesc"-->
<!--            rows="2"-->
<!--            autosize-->
<!--            label="退款备注:"-->
<!--            type="textarea"-->
<!--            placeholder="退款备注"-->
<!--            class="refundDesc"-->
<!--        />-->
<!--      </div>-->

    </van-dialog>
  </div>

</template>

<script>
import {storeList, tableList} from '../mock.js'
import { getList, fakeManuanlRefund, getStoreList} from "@/api/order";
import { Toast } from 'vant'

export default {
  name: "order",
  data(){
    return {
      isShowMore: false, // 是否展示更多的筛选条件
      keyWord: '', // 搜索的关键字
      psp_order_id: '', // '交易单号',
      showStatusPicker: false, // 是否展示出货状态选择框
      orderOutStatus: '', // 出货状态-显示的值
      orderOutStatusVal: '', // 出货状态-传递给后端的值
      outStatusList: ['出货成功(5.0/777)','出货失败(5.0)','等待出货(5.0/777)','结果未知(5.0)','出货超时(5.0)','通讯超时(5.0)',
        '出货异常(5.0)','还未吐货(2.0&3.0)','出货失败(2.0&3.0)','出货超时(2.0&3.0)','等待吐货(2.0&3.0)','吐货成功(2.0&3.0)'],
      outStatusValues: ['SUCCESS', 'FAIL','ING','OVERTIME', '出货超时', '通讯超时', '出货异常', '6','9','8','0','1'],
      allStore: [], // 查询到的总的景区列表
      showStorePicker: false, // 是否展示景区筛选列表
      storeList:[], // 景区选项
      storeIdList: '', // 景区选择的是哪个-显示的值
      storeId: '', // 景区选择的是哪个-传递给后端的值
      showDatePicker: false ,// 日期下拉框是否出现
      dateRange: '近2小时', // 日期-显示出来的
      // dateList: ['近2小时','近一天','近三天','近一周'],
      dateList: ['近2小时','近一天','近三天','近一周','近一月'],
      dateId: '0', // 日期-传递给后端的

      timeRangeList: [ // 时间范围
        { value: '0', label: '近2小时' },
        { value: '1', label: '近一天' },
        { value: '2', label: '近三天' },

        { value: '3', label: '近一周' },
        { value: '4', label: '近一个月' },
        // { value: '5', label: '近三个月' },
      ],

      showCalendar: false, // 是否展示日历选择框
      // calendarStartVal: this.timeFormat(new Date()),
      calendarStartVal: '',
      minDate: new Date(2023, 0, 1),
      calendarEndVal: '',
      showEndCalendar: false,
      tableData: [],
      list: [],
      loading: false,
      finished: false,
      serverTimeNow: "",// 服务器当前的时间，用来计算表格中支付是否已经完成（通过请求来获取的）
      OUT_TIMEOUT: 120000, // 出货超时时间为2分钟，即120000毫秒
      dialogVisible: false, // 模态框是否展示
      dialogForm: {}, // 模态框展示的数据
      page: 1, // 第几页
      pageSize: 10, // 每页几条数据
      total: 30, // 总数据量
      // refundDesc: ''  // 退款备注
      tick: null, // 定时器
      reasonList: [], // 退款原因列表
      reasons: [
        // {label: '商品损坏', value: '1'},
        // {label: '未出货', value: '2'},
        // {label: '重复支付', value: '3'},
        // {label: '景区账号退款失败', value: '4'},
        // {label: '出货与下单商品不符', value: '5'},
        {label: '外壳损坏', value: '6'},
        {label: '纪念章/大牌瑕疵', value: '7'},
        {label: '未出货', value: '8'},
        {label: '重复支付', value: '9'},
        {label: '大牌机器卡死', value: '13'},
        {label: '大牌打印瑕疵', value: '14'},
        {label: '777不出货', value: '15'},
        {label: '777漏墨', value: '16'},
        {label: '出错货', value: '10'}, // 最后的选项
        {label: '7天无理由', value: '11'}, // 最后的选项
        {label: '测试', value: '12'}
      ],
      realReasons: [], // 当前种类的退款原因
    }
  },
  created(){
    this.getAllStore();// 获取全部的景区列表
    this.fetchData()
  },
  mounted(){


  },
  methods: {
    changeShowMore(){ // 切换是否能展示更多的筛选条件
      this.isShowMore = !this.isShowMore;
    },
    keySearch() {
      const temp = this.allStore.filter(val => { // 拿全部的数据去搜索
        return val.storeName.indexOf(this.keyWord) !== -1
      })
      console.log(temp)
      this.storeList = temp.map(val => {
        return `${val.storeName}(${val.genesis})`
      });
    },


    changePage(e){
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      this.page = e;
      this.fetchData();
    },
    resetStoreList(){
      // 重置景区列表（打开下拉框就要重置）
      this.keyWord = ''; // 关键字清空
      this.storeList = this.allStore.map(val => {
        return `${val.storeName}(${val.genesis})`
      })
    },
    handleStorePopUp(){
      // 打开景区下拉列表
      this.resetStoreList();
      this.showStorePicker = true; // 打开下拉框选项

    },
    clearFiled(e){
      // 获取是要清空哪个数据
      const field = e.target.parentNode && e.target.parentNode.previousSibling && e.target.parentNode.previousSibling.name;
      switch(field) {
        case '交易单号':
          this.psp_order_id = '';
          break;
        case '出货状态':
          this.orderOutStatus = ''; // 出货状态-显示的值
          this.orderOutStatusVal = ''; // 出货状态-传递给后端的值
          break;
        case '景区名称':
          this.storeIdList = ''; // 景区选择的是哪个-显示的值
          this.storeId = ''; // 景区选择的是哪个-传递给后端的值
          break;
        case '时间范围':
          this.dateRange = ''; // 日期-显示出来
          this.dateId = ''; // 日期-传递给后端的
          break;
        case '开始日期':
          this.calendarStartVal = '';
          break;
        case '结束日期':
          this.calendarEndVal = '';
          break;

        default:
          console.log('默认')
      }
    },
    getAllStore(){
      const _this = this;
      console.log('getAllStore')
      getStoreList().then(res => {
        console.log(res.body)
        const data  = res.body;
        _this.allStore = data; // 全部的景区数据
        _this.storeList = data.map(val => {
          return val.storeName
        })
      }).catch(e => {
        console.log(e)
      })
      // 这里是mock的假数据，待注释
      // this.allStore = storeList;
      // this.storeList = storeList.map(val => {
      //   return val.storeName
      // });
    },
    async fetchData(){ // 拉取数据
      // let adujstQueryForm = this.formDataHelper(); // 携带了模糊查询要改变的数据结构
      let params = {
        // ...adujstQueryForm,// 开始日期、结束日期
        psp_order_id: this.psp_order_id, // 交易单号
        timeRange: this.dateId, // 时间范围
        order_out_status: this.orderOutStatusVal, // 出货状态
        storeId: this.storeId, // 景区名称
        page: this.page,
        pageSize: this.pageSize
      }
      console.log(params)
      await getList(params).then(res => {
        if(res && res.code === '2000'){
          this.tableData = this.getTreeData(res.body.data) // 这是请求到的列表
          this.page = res.body.page; // 当前页码
          this.total = res.body.totalRecords; // 总共数量
          this.serverTimeNow = res.body.timeNow; // 服务器时间
        }
      }).catch(e =>{
        console.log(e)
      })
      // 这是假的mock数据,要注释掉
      // this.tableData = this.getTreeData(tableList) // 这是请求到的列表
    },
    onSubmit(){
      this.page = 1;// 每次重新点击查询，就去查第一页
      // 查询（3:近一周，4:近一月，这两个情况下，必须要写订单号，否则报错）
      if(this.dateId === '3' || this.dateId === '4'){
        const range = this.dateId === '3'? '周' : '月'
        if(this.psp_order_id === ''){
          this.$toast({
            type: 'fail',
            message: `需（交易单号）才可查询近一${range}数据`
          });
          return
        }
      }

      // // 时间转时间戳
      // const startTime = this.calendarStartVal && Date.parse(this.calendarStartVal) // 开始日期
      // const endTime = this.calendarEndVal && Date.parse(this.calendarEndVal) // 结束日期
      // if(startTime || endTime) { // 只要选择了日期就必须要选择全
      //   if(!startTime){
      //     this.$toast({
      //       type: 'fail',
      //       message: '请选择开始时间日期'
      //     });
      //     return
      //   }
      //   if(!endTime){
      //     this.$toast({
      //       type: 'fail',
      //       message: '请选择结束日期'
      //     });
      //     return
      //   }
      //   if(startTime > endTime){
      //     this.$toast({
      //       type: 'fail',
      //       message: '开始日期不能大于结束日期'
      //     });
      //     return
      //   }
      //
      //   // 计算两个日期之间的差值（毫秒）
      //   const diff = Math.abs(endTime - startTime);
      //
      //   // 将差值转换为天数
      //   const daysDiff = Math.ceil(diff / (1000 * 60 * 60 * 24));
      //   if (daysDiff > 60) {
      //     this.$toast({
      //       type: 'fail',
      //       message: '开始日期与结束日期不能超过60天'
      //     });
      //     return
      //   }
      // }

      this.fetchData();
    },
    onConfirm(value, index){
      // 选择出货状态
      this.orderOutStatus = value;
      this.orderOutStatusVal = this.outStatusValues[index];
      console.log(value, this.orderOutStatusVal)
      this.showStatusPicker = false;
    },
    onStoreConfirm(value, index){
      console.log(value)
      // 选择景区
      this.storeIdList = value;
      // 从原来数据里面，过滤出id
      const valueArr = value.split('(');
      const genesis = valueArr.length > 1 && valueArr[valueArr.length - 1].split(')')[0] // 先确保版本号被切割出来,可能景区里面含有特殊字符，所以从后往前找
      let mineGenesis = `(${genesis})` // 通过版本号去切割前面的景区名称
      const storeName = value.split(mineGenesis)[0];
      console.log('storeName---' + storeName)
      console.log('genesis---' + genesis)

      const currentStore = this.allStore.filter(val => {
        return val.storeName === storeName && val.genesis === genesis
      })
      this.storeId = `${currentStore[0].storeId}-${currentStore[0].genesis}`; // 把版本号携带过去
      this.showStorePicker = false;
    },
    onDateConfirm(value, index){
      this.dateRange = value;
      this.dateId = this.timeRangeList[index].value;
      console.log(value, this.dateId)
      this.showDatePicker = false;
    },
    onCalendarConfirm(value){
      console.log(value)
      this.calendarStartVal = this.timeFormat(value);
      this.showCalendar = false
    },
    onCalendarEndConfirm(value){
      console.log(value)
      this.calendarEndVal = this.timeFormat(value);
      this.showEndCalendar = false
    },
    timeFormat(time) { // 时间格式化 2019-09-08
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      let hour = time.getHours();
      let minute = time.getMinutes();
      return `${year}/${month}/${day} ${hour}:${minute}`
    },
    formatter(type, val) {
      if (type === 'year') {
        return val + '年';
      }
      if (type === 'month') {
        return val + '月';
      }
      if (type === 'day') {
        return val + '日';
      }
      if (type === 'hour') {
        return val + '时';
      }
      if (type === 'minute') {
        return val + '分';
      }
      return val;
    },
    getTreeData(oldData){ // 把数据整理成树状结构

      let newArr = oldData.map((val, index,arr) => {
        const tempOrder = [...val.transaction_info]; // 把数据复制一份，等会用来切割
        tempOrder.shift(); // 把数组里面的第一项去掉

        const publicData = {
          order_id: val.order_id, // 退款要用的数据
          device_code: val.device_code, // 退款要用的数据
          deviceId: val.device_id, // 退款要的设备id
          deviceName: val.device_name, // 退款设备名称

          order_out_status: val.order_out_status, // 出货状态
          order_pay_status: val.order_pay_status, // 支付状态
          add_time: val.add_time_str, // 时间
          amount: val.amount, // 订单金额
          actual_collection: val.actual_collection, // 实付金额
          refund_amount: val.refund_amount, // 已经退款金额
          device_name: val.device_name, // 设备名称
          goods_name: val.goods_name, // 商品名称
          channel: val.channel, // 货道
          genesis: val.genesis, // 数据来源
          device_type: val.device_type, // 设备类型用来区分退款原因的
        }

        const childData = tempOrder.map((inner) => { // 这是重复的订单数据，包含了公共数据+自己私有数据
          return {
            ...publicData,
            ...inner
          }
        })

        return {

          ...publicData,
          isIndex: true,
          parentIndex: index + 1,
          transaction_id: val.transaction_info[0].transaction_id, // 唯一标志
          psp_order_id: val.transaction_info[0].psp_order_id, // 交易单号
          finish_time: val.transaction_info[0].finish_time_str, // 支付时间
          psp_name: val.transaction_info[0].psp_name, // 支付方式
          transaction_status: val.transaction_info[0].transaction_status, // 是否支付成功
          refund_status: val.transaction_info[0].refund_status, // 退款状态
          refund_time: val.transaction_info[0].refund_time_str || '-', // 退款时间
          children: childData
        }
      })
      console.log(newArr)
      return newArr
    },
    onLoad(){
      // 加载更多表单内容this.loading = false; finished=false
      // this.loading = false;
      // this.finished = true;
      console.log('重新拉取数据')
      // this.fetchData()
    },
    // 小工具：计算两个可读时间的时间戳差
    diffTimestamp(now, previous) {
      if (now.indexOf('-')) {
        now = now.split('-').join('/')
      }
      if (previous.indexOf('-')) {
        previous = previous.split('-').join('/')
      }
      return Date.parse(now) - Date.parse(previous)
    },
    handleManualRefund(row, index) {
      console.log(row, row.device_type)
      let commonList = ['10','11','12'];
      let differentList;
      // 根据不同的数据来源区分不同的退款原因
      if(row.genesis === '2.0' || row.genesis === '3.0') {
        // 纪念章
        differentList = ['6','7','8','9', ...commonList];
      }
      if(row.genesis === '5.0' || row.genesis === '5.0大牌') {
        console.log(row.device_type)
        if(row.device_type === 1 || row.device_type === 4){
          // 纪念章
          differentList = ['6','7','8','9', ...commonList];
        } else if(row.device_type === 2) {
          // 776
          differentList = ['8', ...commonList];
        } else if(row.device_type === 3) {
          // 大牌
          differentList = ['13','14', ...commonList];
        }
      }
      if(row.genesis === '777') {
        // 777
        differentList = ['15','16', ...commonList];
      }
      console.log(differentList)
      // 把reasons进行过滤，找到真正能选择的退款原因
      this.realReasons = this.reasons.filter(val =>
          differentList.includes(val.value)
      )
      console.log(this.realReasons)



      // this.refundDesc = ''; // 退款备注
      this.reasonList = []; // 打开弹窗的时候，把退款原因清空
      // 打开弹窗
      this.dialogForm = {
        psp_order_id: row.psp_order_id, // 交易单号
        finish_time: row.finish_time, // 支付时间
        goods_name: row.goods_name, // 商品名称
        amount: row.amount, // 退款金额
        refund_amount: row.refund_amount, // 已经退款金额
        params: { // 退款要传递给接口的数据
          orderId: row.order_id,
          transactionId: row.transaction_id,
          deviceCode: row.device_code,
          amount: String(row.amount),
          genesis: row.genesis, // 系统版本
          pspOrderId: row.psp_order_id,
          deviceId: row.deviceId,
          deviceName: row.deviceName
        }
      }
      console.log(this.dialogForm.params)
      this.dialogVisible = true;
    },
    // 请求手工退款订单翻转
    fakeManuanlRefund() {

      if(this.dialogForm.params.genesis === '777' ){
        if(!this.dialogForm.refundMoney){
          Toast.fail('退款金额不能为空');
          return;
        }
        const reg = /^\d+(\.\d+)?$/;

        if (!reg.test(this.dialogForm.refundMoney)) {
          Toast.fail('只能输入数字');
          return;
        }
        if(this.dialogForm.refundMoney * 100 > (this.dialogForm.amount - this.dialogForm.refund_amount)) {
          Toast.fail('退款金额不能大于可退金额');
          return;
        }

      }
      if(this.dialogForm.params.genesis === '777'){
        this.dialogForm.params.amount = String(this.dialogForm.refundMoney * 100); // 手动退款金额
      }

      if(this.reasonList.length === 0) {
        Toast.fail('请选择退款原因')
        return;
      }

      console.log(this.dialogForm.params)
      const _this = this


      this.$dialog.alert({
        title: '是否确认执行该操作?',
        showCancelButton: true
      }).then(() => {
          // 手动退款金额，需要向上取整
          if (this.dialogForm.params.genesis !== "777") {
            // 手动退款金额，需要向上取整
            this.dialogForm.params.amount = String(
              Number(this.dialogForm.params.amount).toFixed(2)
            );
          }
        fakeManuanlRefund({
          ..._this.dialogForm.params,
          reasonList: this.reasonList.length > 0 ? this.reasonList : undefined, // 退款的原因列表
        })
            .then((res) => {
              // 待开发(更新表格里面的数据),也可以是重新请求数据
              if(res && res.code === '2000') {

                Toast.success('退款成功');
                _this.tick = setTimeout(() =>{
                  _this.dialogVisible = false; // 关闭模态框
                  window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
                  _this.fetchData(); // 重新请求数据
                },2000)
              }
            })
            .catch((err) => {
              Toast.fail('退款异常，请人工核实');
              _this.tick = setTimeout(() =>{
                this.dialogVisible = false;
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
                _this.fetchData(); // 重新请求数据
              },2000)
            })
      }).catch(() => {
        // on cancel
      });
      // if(this.refundDesc){
      //   this.dialogForm.params.refundDesc = this.refundDesc;
      // }



    },
    // form数据清洗
    formDataHelper() {
      let adujstQueryForm = {}; // 这是要传递给后台的请求数据

      if (this.calendarStartVal && this.calendarEndVal) {
        // 时间转时间戳
        adujstQueryForm.startTime = Date.parse(this.calendarStartVal) // 开始日期
        adujstQueryForm.endTime = Date.parse(this.calendarEndVal) // 结束日期
      }

      return adujstQueryForm
    },
  },
  filters:{
    PSPNameFilter(status) {
      const outMap = {
        ali: '支付宝',
        wechat: '微信',
        icbc: '工行',
        union: '银联'
      }
      return outMap[status]
    },
    payStatusFilter(status) {
      const outMap = {
        SUCCESS: '支付成功',
        CANCEL: '取消',
        ING: '等待支付',
      }
      return outMap[status]
    },
    outStatusFilter(status) {
      const outMap = {
        SUCCESS: '出货成功',
        FAIL: '出货失败',
        CANCEL: '出货取消', // 不应该存在的状态，但由于测试的时候没有按照业务逻辑，所以出现的异常状态。
        OVERTIME: '结果未知',
        ING: '等待出货',
        出货超时: '出货超时',
        通讯超时: '通讯超时',
        出货异常: '出货异常',
        还未吐货: '还未吐货',
        出货失败: '出货失败',
        等待吐货: '等待吐货',
        吐货成功: '吐货成功'


      }

      return outMap[status]
    },
    statusFilter(status) {
      const statusMap = {
        SUCCESS: 'success',
        CANCEL: 'primary',
        DOUBLEPAY: 'danger',
        FAIL: 'danger',
        ING: 'primary',
        MANUALREFUND: 'primary',
        AUTOREFUND: 'primary',
        OVERTIME: 'warning',
        出货超时: 'warning',
        通讯超时: 'warning',
        出货异常: 'danger',
        还未吐货: 'warning',
        出货失败: 'danger',
        等待吐货: 'default',
        吐货成功: 'success',
        WAZ: 'danger' // 兜底的异常状态
      }
      return statusMap[status]
    },
    refundStatusFilter(status) {
      const outMap = {
        AUTOREFUND: '自动退款',
        MANUALREFUND: '手工退款',
        REFUNDALL: '全部退款',
        REFUNDPART: '部分退款',
        '': '未退款', // 待后续使用
      }
      return outMap[status]
    },
  },
  beforeDestroy() {
    if(this.tick){
      clearTimeout(this.tick)
    }
  }
}
</script>

<style scoped>
.showMoreBox {
  text-align: right;
  margin-top: 10px;
  color: #2ad1c4;
}

.order_form {
  border: 1px solid #cccccc;
  border-radius: 30px;
  padding: 20px 10px 10px 10px;
  margin: 10px 0;
  font-size: 14px;
}

.listBox {
  box-shadow: 0 0 15px #8dd3ce;
  margin-bottom: 20px;
  font-size: 14px;
  padding: 10px 15px;
  /*border: 1px solid #8dd3ce;*/
  border-radius: 30px;
}

.table_row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 3px;
  font-size: 14px;
}

.table_row div:nth-child(1){
  width: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}


.table_row div:nth-child(2){
  width: calc(100% - 100px);
  word-break: break-all;
}


.phonePage {
  width: 90%;
  margin: 3.5em auto 0 auto;
  /*margin-top: 3.5em;*/
  padding-bottom: 3em;
}

.phonePage .van-tag {
  font-size: 14px;
}

.innerBox {
  box-shadow: 0 0 15px #ff976a;
  margin-bottom: 20px;
  font-size: 14px;
  padding: 10px 15px;
  border-radius: 30px;
  margin-top: 20px;
}

.searchBox {
  width: 90%;
  margin: 5px auto;
  border: 1px solid #8dd3ce;
  border-radius: 30px;
}

.storeBox {
  margin-bottom: 30px;
}

.noData {
  text-align: center;
  color: #8dd3ce;
  font-size: 14px;
}

.refundDesc {
  border: 1px solid #ff976a;
  border-radius: 10px;
  margin-top: 10px;
}

.van-checkbox {
  margin-top: 2px;
}

.myCheckBox {
  max-height: 250px;
  overflow: auto;
}

</style>

<style>
.van-dialog__content {
  padding: 10px 20px;
}

.van-picker-columns{
  border-top: 1px solid #8dd3ce;
}
</style>